<template>
    <div class="lottery">
        <div class="container">
            <div class="cat">
                <div class="slotArea" :class="{'active':move}">
                </div>
            </div>
            <img src="../assets/slot-btn.svg" alt="點我抽獎" class="slotBtn" @click="lottery">
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import debounce from "lodash.debounce";
import { getApi } from "@/utils/callApi";
import apiConfig from "@/utils/apiConfig";
import Swal from "sweetalert2/dist/sweetalert2";
import { useRouter } from "vue-router";

const router = useRouter();
const move = ref(false);

const lottery = debounce(() => {
    move.value = true;
    const jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
    getApi(apiConfig.activityDomain + apiConfig.lottery, jwtInfo.token)
        .then((response) => {
            if (response.data.code === 200) {
                if (response.data.data.whetherWinLottery === "Y") {
                    setTimeout(() => {
                        Swal.fire({
                            title: response.data.data.prizeName,
                            html:
                                '<p class="prizeIntro">' + response.data.data.prizeInstruction + "</p>" +
                                '<a href="' + response.data.data.prizeLink + ' " target="_blank">' + response.data.data.prizeLink + "</a>" +
                                "<p>開啟密碼 : " + response.data.data.prizeCode + "</p>" +
                                "<p>" + response.data.data.prizeDescription + "</p>",
                            imageUrl: response.data.data.prizeImageLink,
                            confirmButtonText: "確定",
                            customClass: {
                                container: "lotterySuccess",
                            },
                        }).then(function () {
                            move.value = false;
                        });
                    }, 600);
                } else {
                    setTimeout(() => {
                        Swal.fire({
                            title: response.data.data.prizeName,
                            html:
                                '<p class="text">' +
                                response.data.data.prizeDescription +
                                "</p>",
                            imageUrl: response.data.data.prizeImageLink,
                            confirmButtonText: "確定",
                            customClass: {
                                container: "lotterySuccess",
                            },
                        }).then(function () {
                            move.value = false;
                        });
                    }, 600);
                }
            } else if (response.data.code === 404) {
                Swal.fire({
                    title: "很可惜~",
                    text: "未中獎",
                    confirmButtonText: "確定",
                    customClass: {
                        container: "lotteryFail",
                    },
                }).then(function () {
                    move.value = false;
                });
            } else if (response.data.code === 400) {
                Swal.fire({
                    title: "謝謝您的參加",
                    text: response.data.message,
                    confirmButtonText: "確定",
                    customClass: {
                        container: "lotteryFail",
                    },
                }).then(function () {
                    move.value = false;
                    router.push("/FY24_luckydraw");
                });
            }
        })
        .catch(() => {
            Swal.fire({
                title: "網路錯誤",
                text: "連線錯誤",
                confirmButtonText: "確定",
            }).then(function () {
                move.value = false;
            });
        });
}, 500);
</script>
<style lang="scss">
.lottery{
    margin-top: 95px;
    background:url("../assets/slot-bg.svg") center top / cover no-repeat;
    background-color: #BDBCDE;
    @media screen and (max-width: $mobile-large){
        background-image: url("../assets/slot-bg-m.svg");
        background-position: center top;
        background-size:cover;
        margin-top:95px;
        height: 100%;
    }
    .container{
        position: relative;
        height: 90vh;

        @media screen and (max-width: $nb){
            padding-bottom: 20%;
        }
        .cat{height:100%;display: flex;flex-direction: column;align-items: center;justify-content: center;}
        .slotArea{
            width: 480px;
            height:563px;
            background-image: url("../assets/slot01.svg");
            background-size:cover;
            background-position: left top;
            background-repeat: no-repeat;
            display: block;
            margin:0 auto;
            &.active{
                -webkit-animation: PCplay 0.5s steps(3);
                animation: PCplay 0.5s steps(3);
                background-position: right -1px top;
            }

            @media screen and (max-width: $pc) {
                right:5%;
            }
            @media screen and (max-width: $pc) and (max-height: 600px) {
                width: 500px;
                height: 500px;
                background-size: cover;
                background-position: left top;
                background-repeat: no-repeat;
                &.active{
                    -webkit-animation: play 0.5s steps(3) reverse;
                    animation: play 0.5s steps(3) reverse;
                    background-image: url("../assets/slot01.svg");
                    background-position: right -1px top;
                }
            }
            @media screen and (max-width: $nb){
                position:static;
                margin:0 auto;
            }
            @media screen and (max-width: $mobile-small){
                width:267px;
                height:313px;
                &.active{
                    -webkit-animation: Mplay 0.5s steps(3,end);
                    animation: Mplay 0.5s steps(3,end);
                    background-image: url("../assets/slot01.svg");
                    background-position: right top;
                }

            }
        }
        @keyframes fade {
            from {
                transform: scale(1);
            }
            50% {
                transform: scale(1.1);
            }
            to {
                transform: scale(1);
            }
        }

        .slotBtn{
            cursor: pointer;
            transition: all linear 0.8s;
            animation: fade 900ms ease-in-out infinite;
            width:163px;
            position: absolute;
            bottom:80px;
            left:50%;
            margin-left:-81.5px;
            @media screen and (max-width: $nb){
                top:inherit;
                right: 20%;
            }
            @media screen and (max-width: $pad){
                top: inherit;
                left: 50%;
                margin-left: -90px;
                width:180px;
            }
            @media screen and (max-width: $mobile-small){
                width:120px;
                margin-left: -60px;
            }
            &:hover{
                animation: stop;
                transform: scale(1.2);
                transition: all linear 0.8s;
            }
        }
    }
}
@-webkit-keyframes PCplay {
    from { background-position:0; }
    to { background-position: -1850.96px; }
}

@keyframes PCplay {
    from { background-position: 0; }
    to { background-position: -1890px; }
}
@-webkit-keyframes play {
    from { background-position:0; }
    to { background-position: -1500px; }
}

@keyframes play {
    from { background-position: 0; }
    to { background-position: -1500px; }
}
@-webkit-keyframes Mplay {
    from { background-position:0; }
    to { background-position: -1050px; }
}

@keyframes Mplay {
    from { background-position: 0; }
    to { background-position: -1050px; }
}
.lotteryFail{
    font-family: 'Noto Sans TC', '微軟正黑體', sans-serif;
    .swal2-show {
        &::before {
            content: url("../assets/popup-0.svg");
            margin: -60px auto 0;
        }
    }
    .swal2-html-container{
        color:$blue-700;
        font-weight:bold;
        font-size:25px;
    }
    .swal2-popup{
        width:25em;
        border-radius:20px;
    }
}
.lotterySuccess{
    font-family: 'Noto Sans TC', '微軟正黑體', sans-serif;
    .swal2-image{ margin: -120px auto 0;max-width:214px;}
    .swal2-html-container{
        color:#2D2D2D;
        text-align:left;
        p{font-size:16px;
            &.prizeIntro{
                font-size: 20px;
                text-align:center;
                margin: 0 auto 10px;
            }
            &.text{
                text-align: center;
            }
        }
        a{font-size:16px;color:#3179fa;word-break: break-all;text-decoration: underline;text-align: left;margin-bottom: 10px;
            display: inline-block;}
    }
    .swal2-title{
        color:#005bac!important;
        border-bottom:0!important;
        padding:0!important;
    }
    .swal2-popup{
        width:25em;
        border-radius:20px;
    }

}
</style>



